<template>
    <div class="wrap" ref='res' :tabindex="Math.random()" title="双击编辑" :class="{ active: editable }" @click.prevent.stop="() => {}" @dblclick.prevent.stop="dblclick" :contenteditable="editable" >
        <slot></slot>
    </div>
</template>

<script>
import service from '../assets/js/service'
export default {
    name: "DataText",
    data: () => ({
        editable: false
    }),
    props: {
        flag: {
            type: String,
            required: true
        }
    },
    mounted() {
        service.add(this.flag);
        window.addEventListener('click', () => {
            this.editable = false
        })
    },
    methods: {
        dblclick() {
            this.editable = true
            
            if (window.getSelection) {
                if (window.getSelection().collapse) {
                    window.getSelection().collapseToStart();
                }
            }
        }
    }
};
</script>

<style scoped>
.wrap {
    display: inline-block;
    position: relative;
    z-index: 1;
    outline: 0;
}

.wrap.active {
    z-index: 10;
}

.wrap:hover::before {
    top: -8px;
    left: -10px;
    right: -10px;
    bottom: -8px;
    position: absolute;
    border: 1px solid #dedede;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    background: #fff;

    content: '';
    z-index: -1;
}

.wrap.active::before {
    top: -8px;
    left: -10px;
    right: -10px;
    bottom: -8px;
    position: absolute;
    border: 1px solid #acacac;
    box-shadow: 0 0 10px rgba(0, 0, 0, .15);
    background: #fff;

    content: '';
    z-index: -1;
}

</style>
